<template>
  <vue-apex-charts
    type="bar"
    :height="height"
    :options="barChart.chartOptions"
    :series="barChart.series"
  ></vue-apex-charts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: { VueApexCharts },
  props: ['height', 'series', 'labels'],
  data () {
    return {
      themeColors: ['#7367F0', '#28C76F'],
      barChart: {
        series: [
          {
            data: this.series
          }
        ],
        chartOptions: {
          colors: this.themeColors,
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          xaxis: {
            categories: this.labels
          }
        }
      }
    }
  }
}
</script>
 